import { IndexApiSet,useIndexApi } from 'utils/network/api_hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'
import { InstitutionPriceVersion } from 'entities/institution_price_version'

type InstitutionPriceVersionsResponse = PagingResponse & {
    results: InstitutionPriceVersion[]
}

export function useFetchInstitutionPriceVersionsApi(): IndexApiSet<InstitutionPriceVersionsResponse> & { execute: () => void } {
    const apiPath = 'institution_price_versions/'
    const api = useIndexApi<InstitutionPriceVersionsResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
        initialState: { page: 1, perPage: 9999 },
    })

    const execute = (): void => {
        api.execute(apiPath)
    }

    return { ...api, execute }
}
